import type { ButtonHTMLAttributes, ReactNode } from 'react'
import { btn, btnBase, cx } from './classes'

export type IconButtonTone = 'danger' | 'neutral' | 'ghost'
export type IconButtonSize = 'sm' | 'md'

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Смысл действия: используется как aria-label и title. */
  label: string
  tone?: IconButtonTone
  size?: IconButtonSize
  children: ReactNode
}

/**
 * Стандарт кнопок-иконок системы.
 *
 * База — общий `btnBase` (скругление, transition, focus-ring, disabled),
 * тон — из утверждённой палитры `btn`. Поэтому кнопка удаления в чеке,
 * каталоге и админке выглядит одинаково и меняет цвет при наведении.
 */
const TONE: Record<IconButtonTone, string> = {
  danger: btn.dangerGhost,
  neutral: btn.secondary,
  ghost: btn.ghost
}

const SIZE: Record<IconButtonSize, string> = {
  sm: 'h-8 w-8 p-0 text-small',
  md: 'h-11 w-11 p-0 text-base2'
}

export function IconButton({
  label,
  tone = 'neutral',
  size = 'sm',
  className,
  children,
  ...rest
}: IconButtonProps) {
  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      className={cx(btnBase, TONE[tone], SIZE[size], className)}
      {...rest}
    >
      {children}
    </button>
  )
}
